import React from 'react';
import { List } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { resolveRequestWorkflow } from '../state/state';

const RequestTransferredAsListItem = ({ transferType }) => (
  <List.Item className="aridhia-request-transferred-as-list-item">
    <List.Header>
      <FormattedMessage id="request.list.transfer.type.title" />
    </List.Header>
    <List.Description className="aridhia-form-item-description">
      <FormattedMessage id={`transfer.type.${transferType}`} />
    </List.Description>
  </List.Item>
);

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps, { transfer: { transfer_type: '' } });
  return ({ transferType: request.transfer.transfer_type });
};

export default connect(mapStateToProps)(RequestTransferredAsListItem);
